import { render, staticRenderFns } from "./ContentBtns.vue?vue&type=template&id=10c8fb16"
import script from "./ContentBtns.vue?vue&type=script&lang=js"
export * from "./ContentBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports